import * as Comlink from 'comlink';

import { getUniqueGroupByValues, groupSeriesByColumn } from '../utils/group-series-by-column';
import { getVisualizationProps } from '../workflows';
import { getVisualizationPropsEnhanced } from '../workflows/get-visualization-props-enhanced';

const workerApi = {
    getUniqueGroupByValues: getUniqueGroupByValues,
    groupSeriesByColumn: groupSeriesByColumn,
    getVisualizationProps: getVisualizationProps,
    getVisualizationPropsEnhanced: getVisualizationPropsEnhanced,
};

export type VisualizationWorkerApi = typeof workerApi;

Comlink.expose(workerApi);
